<template>
    <div :class="isPad?'card-border':''">
      <a-row  class="info-row">
        <a-col :span="isPad?10:8">
          <a-avatar  :size="64" :src="require('@/assets/head/'+ (patient.sex==='0'?'woman':'man')+'.jpg')" />
        </a-col>
        <a-col :span="isPad?14:16">
          <a-row>
            <a-col :span="isPad?24:12" class="info1">{{patient.patientNum}}</a-col>
            <a-col :span="isPad?24:12" class="info1 one-row">{{patient.name}}</a-col>
          </a-row>
          <div class="info2" v-if="!isPad">
            <label :style="{color:patient.sex==='0'?'#ff5128':'#2290ff'}">{{patient.sex == '1'?'男':'女'}}</label>
            <label style="margin-left: 20px;">{{patient.age}}岁</label>
            <label style="margin-left: 30px">{{getIdcardStr()}}</label>
          </div>
          <div class="info2" v-else>
            <div>
              <label :style="{color:patient.sex==='0'?'#ff5128':'#2290ff'}">{{patient.sex == '1'?'男':'女'}}</label>
              <label style="margin-left: 10px;">{{patient.age}}岁</label>
            </div>
            <div>
              <label >{{getIdcardStr()}}</label>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-row class="info-row" v-if="!isPad">
        <a-col :span="6">
          联系电话：
        </a-col>
        <!-- <a-col :span="12" >
          <a-tooltip v-if="patient.teleType3" >
            <template slot="title">
              <div >
                {{getteleTypeName(patient.teleType3)}}-{{patient.telephone3}}
              </div>
            </template>
            <a >更多联系电话......</a>
          </a-tooltip>
          <label v-else>-</label>
        </a-col> -->
        <a-col :span="10" v-if="patient.teleType1">
          {{getteleTypeName(patient.teleType1)}}-{{patient.telephone1}}
        </a-col>
          <label v-else>-</label>
        <!-- <a-col :span="12" v-if="patient.teleType2">
          {{getteleTypeName(patient.teleType2)}}-{{patient.telephone2}}
        </a-col> -->
        <!-- <div class="info-row">
          <a-tooltip v-if="patient.description">
            <template slot="title">
              {{patient.description}}
            </template>
            <div >
              备注：{{patient.description}}
            </div>
          </a-tooltip>
          <div v-else>
            备注：-
          </div>
        </div> -->
      </a-row>
      <a-row class="info-row" v-if="!isPad">
          <div class="info-row">
          <a-tooltip v-if="patient.description">
            <template slot="title">
              {{patient.description}}
            </template>
            <div >
              备注：{{patient.description}}
            </div>
          </a-tooltip>
          <div v-else>
            备注：-
          </div>
        </div>
      </a-row>
      

      <div class="info-row" v-else>
        <!-- <template v-if="!patient.teleType1 && !patient.teleType1 && !patient.teleType1">暂无联系方式</template> -->
        <template>
          <a-row v-if="patient.teleType1">
            <a-col :span="6">
              {{getteleTypeName(patient.teleType1)}}：
            </a-col>
            <a-col :span="6" >
              {{patient.telephone1}}
            </a-col>
          </a-row>
          <a-row v-if="patient.teleType2">
            <a-col :span="8">
              {{getteleTypeName(patient.teleType2)}}：
            </a-col>
            <a-col :span="16" >
              {{patient.telephone2}}
            </a-col>
          </a-row>
          <a-row v-if="patient.teleType3">
            <a-col :span="8">
              {{getteleTypeName(patient.teleType3)}}：
            </a-col>
            <a-col :span="16" >
              {{patient.telephone3}}
            </a-col>
          </a-row>
        </template>
        <template v-if="moreInfoOpenVisible">
            <a-tooltip v-for="field in fieldList">
              <template slot="title">
                {{field.value}}
              </template>
              <div class="one-row ">
                {{field.name}}：{{field.value}}
              </div>
            </a-tooltip>
        </template>
        <div style="text-align: right">
          <a @click="moreInfoOpen" v-if="!moreInfoOpenVisible">更多信息</a>
          <a @click="moreInfoClose" v-if="moreInfoOpenVisible">收起</a>
        </div>
      </div>
      <slot></slot>
    </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  export default {
    name: 'PatientInfoCard',
    props:{
      patient:{
        type:Object,
        default:function(){
          return {
            telephoneList:[]
          }
        }
      },
      isPad:{
        type:Boolean,
        default:false,
      }
    },
    data(){
      return {
        teleTypeList:[
          {value:'1',text:'本人'},
          {value:'2',text:'配偶'},
          {value:'3',text:'子女'},
          {value:'4',text:'父母'},
          {value:'5',text:'朋友'},
          {value:'6',text:'其他亲戚'},
          {value:'9',text:'其他'},
        ],
        moreInfoOpenVisible:true,
        fieldList:[],
      }
    },
    mounted(){
      // 获取自定义字段
      getAction('/patient/patientFieldValue/listAll',{patientId:this.patient.id,type:'2'}).then(res=>{
        if(res.success){
          this.fieldList = res.result
          this.fieldList.forEach(field=>{
            if(field.input === '4'){
              console.log("field.selectData:"+ field.selectData)              
              field.selectList = JSON.parse(field.selectData)
              console.log("field.selectList:"+ field.selectList)   
              field.selectList.forEach(select=>{
                if(select.value === field.value){
                  field.value = select.text
                }
              })
            }
          })
        }
      })
    },
    methods:{
      moreInfoOpen(){
        this.moreInfoOpenVisible = true
      },
      moreInfoClose(){
        this.moreInfoOpenVisible = false
      },
      getIdcardStr(){
        let value = '*****'
        if(this.patient.idcard){
          if(this.patient.idcard.length >4){
            value = '*'+ this.patient.idcard.substring(this.patient.idcard.length-4,this.patient.idcard.length)
          }
        }
        return value
      },
      getteleTypeName(type){
        let typeName='未知'
        this.teleTypeList.forEach(item=>{
          if(item.value===type){
            typeName = item.text
          }
        })
        return typeName
      },
    }
  }
</script>

<style scoped lang="less">
  .card-border{
    border:1px solid rgba(57,188,206,0.5);
    padding: 5px;
    background-color: rgba(255,255,255,0.5);
    border-radius: 5px;
  }
</style>